<template>
   <div>
       <PageHeader :linkto="'/home'" :linkttitle="'返回'" title=""></PageHeader>
       <b-container v-if="show" class="bg-white px-2 px-md-5 pb-5  shadow-sm rounded ">
           <div class="text-center py-3">
               <h3>尊榮優惠方案</h3>
               <p>不定期推出優惠方案，享受圈內頂級優惠！</p>
           </div>
           <div  v-if="shopcard.length==0" >
               <b-card :header="''" class="text-center mt-0 ">
                   <b-card-text>
                       尚無優惠方案
                   </b-card-text>
                   <b-button  variant="outline-secondary"  @click="load()" :disabled="reload">  <b-spinner small v-if="reload"></b-spinner>重新讀取</b-button>
               </b-card>
           </div>
           <div v-else>

               <div v-for="(item,index) in shopcard" v-bind:key="index" >
                   <b-card v-if="item.product_detail" :header="''" class="text-center mt-3">

                           <b-card-text>
                               <p v-if="item.status==0">優惠方案</p>
                               <p v-if="item.status==2" class="text-danger">優惠方案已過期，請與您的業務聯繫獲得優惠方案</p>
                               <h4>{{ item.product_detail.product_name }}</h4>
                               <h3 class="text-success">{{ Currency(item.product_detail.price) }}<span class="h6">元</span></h3>
                               <p>{{ item.product_detail.product_desc }}</p>

                               <div v-if="payStatus">
                                   <div v-if="item.product_detail.plan_type==3">
                                       <b-button  v-if="item.status==0" class="mt-3" variant="success" block @click="getGift(item)"><b-spinner small v-if="reloadgift"></b-spinner> 領取贈點</b-button>
                                       <b-button v-if="item.status==2" class="mt-3" variant="secondary" block @click="delShopCard(item.id)">刪除過期訂單</b-button>
                                   </div>
                                   <div v-if="item.product_detail.plan_type==2">
                                       <b-button v-if="item.status==0" class="mt-3" variant="success" block @click="gotocheckOut(item,'period')">前往購買</b-button>
                                       <b-button v-if="false" disabled variant="dark" size="lg"  block>系統維護中，暫停交易</b-button>
                                       <b-button v-if="item.status==2" class="mt-3" variant="secondary" block @click="delShopCard(item.id)">刪除過期訂單</b-button>
                                   </div>
                                   <div v-if="item.product_detail.plan_type==1">
                                       <b-button v-if="item.status==0" class="mt-3" variant="success" block @click="gotocheckOut(item,'normal')">前往購買</b-button>
                                       <b-button v-if="false" disabled variant="dark" size="lg"  block>系統維護中，暫停交易</b-button>
                                       <b-button v-if="item.status==2" class="mt-3" variant="secondary" block @click="delShopCard(item.id)">刪除過期訂單</b-button>
                                   </div>
                               </div>
                               <div v-else>
                                   <b-button  class="mt-3"  block disabled >系統維護中，暫停交易</b-button>
                               </div>


                           </b-card-text>

                   </b-card>
               </div>

           </div>
           <div v-if="shopcard.length > 0" class="text-center pt-2">
               <b-button  variant="outline-secondary"  @click="load()" :disabled="reload">  <b-spinner small v-if="reload"></b-spinner>重新讀取</b-button>
           </div>




       </b-container>


   </div>
</template>

<script>
import {mapState} from 'vuex'
import PageHeader from '@/components/PageHeader.vue'

import { alertModel,toCurrency } from '@/service/commuse'

export default {
  name: 'ShopCard',
  components: {PageHeader},
  computed: {
    ...mapState(['plan']),

  },
  data () {
    return {
      payStatus:false,
      show:false,
      shopcard:'',
      reload:false,
      reloadgift:false
    }
  },
  mounted () {
    this.appStatus()
    this.load()

  },
  methods: {
    load(){
      this.reload = true
      this.$store.dispatch('actionGetInvite', {})
        .then((res) => {
          console.log(res)
          this.reload = false
          this.show = true
          this.shopcard = res.data
        }).catch((res) => {
        this.reload = false
      })
    },
    getGift(item){

      this.reloadgift = true
      this.$store.dispatch('actionPointGift', {
        id:item.id,
        suuid:item.suuid,
        puid:item.puid
      }).then((res) => {
        this.reloadgift = false
          alertModel(this,"系統訊息",res.message)
          this.$store.dispatch('actionGetMemberInfo', {})
        this.load()
        }).catch((res) => {
        alertModel(this,"系統訊息",res.message)
        this.reloadgift = false
        // this.loading = false
      })
    },
    gotocheckOut(item,way){



      this.$store.dispatch('actionShopCart',item.product_detail)

      let orderData = {
        id:item.id,
        suuid:item.suuid,
        puid:item.puid,
        ChoicePay:way
      }


      this.$store.dispatch('actionOrderPurchase',orderData)
      // this.$router.push('/Payment/SalesEcpay');

      // this.$store.dispatch('actionSalesECpay', orderData
      // ).then((res) => {
      //     document.open();
      //     document.write(res);
      //     document.close();
      // }).catch((res) => {
      //   // this.loading = false
      // })

      this.$store.dispatch('actionPuidDo', {puid:orderData.puid}).then((res) => {


        switch (res.data.do){
          case "contract-lv2":
            this.$router.push('/Payment/Contract');
            break
          case "contract-lv3":
            this.$router.push('/Payment/AgentContract');
            break
          case "gotopay":
            this.$store.dispatch('actionSalesNBpay', orderData).then((res) => {
              document.open();
              document.write(res);
              document.close();
            }).catch((res) => {})
            break
        }




      }).catch((res) => {})

    },
    Currency(num){
      return toCurrency(num)
    },
    delShopCard(id){
      this.$store.dispatch('actionInvitePlanClean', {
        id:id
      })
        .then((res) => {
          alertModel(this,"系統訊息",res.message)
          this.load()
        }).catch((res) => {
        alertModel(this,"系統訊息",res.message)
        // this.loading = false
      })
    },
    appStatus(){

      this.$store.dispatch('actionGetAppStatus',{})
        .then((res) => {

          this.payStatus = res.data.payment

        })
        .catch((res) => {

        })
    }



  }
}
</script>

